module.exports = __webpack_public_path__ + "static/img/wc.f9434d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wc.png
// module id = kee2
// module chunks = 0